import { forwardRef, useImperativeHandle, useState } from 'react';

const TabMenu = ({ title, tabNo, selected, setTabNo }) => {
    const onClick = () => {
        setTabNo(tabNo);
    };

    return (
        <div className='tab-menu'>
            <button type='button' className={'btn tab-btn ' + (selected ? 'active' : '')} onClick={() => onClick()}>
                {title}
            </button>
        </div>
    );
};

const NullView = () => {
    return <></>;
};

const TabBox = forwardRef(({ defaultTabNo }, ref) => {
    const [tabs, setTabs] = useState([]);
    const [tabNo, setTabNo] = useState(defaultTabNo);

    useImperativeHandle(ref, () => ({
        initTab: (
            // element: { tabNo: 탭 번호, title: 탭 명, element: 탭 엘레멘트 }
            tabs,
            // defaultTabNo: 탭 번호
            defaultTabNo = 1,
        ) => {
            setTabs(tabs);
            setTabNo(defaultTabNo);
        },
        selectTab: (tabNo) => {
            setTabNo(tabNo);
        },
    }));

    return (
        <div className='tab-container'>
            <div className='tab-header'>
                {tabs.map((tab, index) => (
                    <TabMenu
                        key={index}
                        title={tab.title}
                        tabNo={tab.tabNo}
                        selected={tab.tabNo == tabNo}
                        setTabNo={setTabNo}
                    />
                ))}
            </div>
            {tabs.map((tab, index, array) =>
                tab.tabNo == tabNo ? tab.element : <NullView key={index + array.length + 1}></NullView>,
            )}
        </div>
    );
});

export default TabBox;
